module.exports = __webpack_public_path__ + "img/erudio_engaging.605964bb.svg";